<template>
  <div class="header-image-title" :style="backgroundImg" :class="{'no-photo': !photo}">
    <div class="header-image-slot" :class="{'semi-transparent': !noTransparency}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    photo: {
      type: String,
      default: "",
    },
    noTransparency: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backgroundImg() {
      return { backgroundImage: `url(${this.photo})` };
    },
  },
};
</script>

<style lang="scss">
.header-image-title {
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: black;
  height: 30vh;
  max-height: 350px;

  &.no-photo {
    height: 100%;

    .header-image-slot {
      position: relative;
    }
  }

  .header-image-slot {
    position: absolute;
    margin: 0;
    color: white;
    left: 0;
    right: 0;
    bottom: 0;
    height: 50px;

    h2,
    label,
    h3 {
      margin: 0;
    }

    &.semi-transparent {
      background: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
